<script>
import { has_priv, is_logged_in, get_claims, logout } from "../service/login.js";
import { has_feature } from "../service/features.js";
import { get_player_count } from "../service/stats.js";
import { get_unread_count } from '../service/mail.js';

import StatsDisplay from './StatsDisplay.vue';
import NavDropdown from "./NavDropdown.vue";
import SkinPreview from "./SkinPreview.vue";
import ThemeSwitcher from "./ThemeSwitcher.vue";

export default {
	methods: {
		has_priv: has_priv,
		has_feature: has_feature,
		logout: function(){
			logout().then(() => this.$router.push("/login"));
		}
	},
	computed: {
		get_player_count: get_player_count,
		is_logged_in: is_logged_in,
		get_claims: get_claims,
		get_unread_count: get_unread_count
	},
	components: {
		"stats-display": StatsDisplay,
		"nav-dropdown": NavDropdown,
		"skin-preview": SkinPreview,
		"theme-switcher": ThemeSwitcher
	}
};
</script>

<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  	<div class="container-fluid">
  		<router-link to="/" class="navbar-brand">Minetest Web UI</router-link>
  		<ul class="navbar-nav me-auto mb-2 mb-lg-0" v-if="is_logged_in">
  			<li class="nav-item" v-if="has_priv('interact')">
  				<router-link to="/" class="nav-link">
  					<i class="fa fa-home"></i> Home
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_feature('minetest_web')">
  				<router-link to="/play" class="nav-link">
  					<i class="fa fa-play"></i> Play
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_priv('interact')">
  				<router-link to="/playersearch" class="nav-link">
  					<i class="fa fa-magnifying-glass"></i> Player search
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_priv('interact') && has_feature('shell')">
  				<router-link to="/shell" class="nav-link">
  					<i class="fa-solid fa-terminal"></i> Shell
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_priv('shout') && has_feature('chat')">
  				<router-link to="/chat" class="nav-link">
  					<i class="fa-solid fa-comment"></i> Chat
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_priv('interact') && has_feature('mesecons')">
  				<router-link to="/mesecons" class="nav-link">
  					<i class="fa-solid fa-microchip"></i> Mesecons
  				</router-link>
  			</li>
  			<li class="nav-item">
  				<router-link to="/online-players" class="nav-link">
  					<i class="fa fa-users"></i> Online players
  					<span class="badge rounded-pill bg-info">
  						{{get_player_count}}
  					</span>
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_feature('mail')">
  				<router-link to="/mail" class="nav-link">
  					<i class="fa-solid fa-envelope"></i> Mail
  					<span class="badge rounded-pill bg-info" v-if="get_unread_count">
  						{{get_unread_count}}
  					</span>
  				</router-link>
  			</li>
  			<li class="nav-item" v-if="has_feature('skinsdb')">
  				<router-link to="/skin" class="nav-link">
  					<i class="fa-solid fa-user-astronaut"></i> Skin
  				</router-link>
  			</li>
  			<nav-dropdown v-if="has_priv('ban')" icon="hammer" name="Moderation">
  				<li v-if="has_feature('xban')">
  					<router-link to="/xban" class="dropdown-item">
  						<i class="fa fa-ban"></i> XBan
  					</router-link>
  				</li>
  				<li>
  					<router-link to="/log" class="dropdown-item">
  						<i class="fa fa-magnifying-glass"></i> Logs
  					</router-link>
  				</li>	
  			</nav-dropdown>
  			<nav-dropdown v-if="has_priv('server')" icon="screwdriver-wrench" name="Administration">
  				<li>
  					<router-link to="/filebrowser/" class="dropdown-item">
  						<i class="fa-solid fa-folder"></i> Filebrowser
  					</router-link>
  				</li>
  				<li>
  					<router-link to="/features" class="dropdown-item">
  						<i class="fa fa-tags"></i> Features
  					</router-link>
  				</li>
  				<li v-if="has_feature('luashell')">
  					<router-link to="/lua" class="dropdown-item">
  						<i class="fa-solid fa-terminal"></i> Lua
  					</router-link>
  				</li>
  				<li v-if="has_feature('minetest_config')">
  					<router-link to="/minetest-config" class="dropdown-item">
  						<i class="fa fa-cog"></i> Minetest config
  					</router-link>
  				</li>
  				<li v-if="has_feature('modmanagement')">
  					<router-link to="/mods" class="dropdown-item">
  						<i class="fa fa-cubes"></i> Mods
  					</router-link>
  				</li>
  				<li v-if="has_feature('mediaserver')">
  					<router-link to="/mediaserver" class="dropdown-item">
  						<i class="fa fa-photo-film"></i> Mediaserver
  					</router-link>
  				</li>
  				<li>
  					<router-link to="/restart-conditions" class="dropdown-item">
  						<i class="fa fa-refresh"></i> Restart conditions
  					</router-link>
  				</li>
  			</nav-dropdown>
  		</ul>
  		<div class="d-flex">
  			<stats-display class="navbar-text" style="padding-right: 10px;"/>
  			<div class="btn-group" v-if="is_logged_in">
  				<button class="btn btn-outline-secondary">
  					<router-link to="/profile">
  						<skin-preview :playername="get_claims.username"/>
  						<span>
  							Logged in as <b>{{get_claims.username}}</b>
  						</span>
  					</router-link>
  				</button>
  				<button class="btn btn-secondary" v-on:click="logout">
  					<i class="fa-solid fa-right-from-bracket"></i>
  					Logout
  				</button>
  			</div>
  			<theme-switcher/>
  		</div>
  	</div>
  </nav>
</template>
